import { jsx as _jsx } from "react/jsx-runtime";
import { CatIconSuccessFilled } from '@blocks-react/components/Icons/SuccessFilled';
import styles from '../MyEquipment.module.scss';
import { Conditional } from '../../common';
export const MyEquipmentCatIconSuccess = ({ showIcon }) => {
    return (_jsx(Conditional, { test: showIcon, children: _jsx(CatIconSuccessFilled, { slot: "after", "data-testid": "serial_validation", className: styles['cat-icon-success-filled'] }) }));
};
